import { Table } from '@dixa/lib-shared-habla';
import { type Table as TanstackTable } from '@tanstack/react-table';
import type { SearchConversationEnriched } from 'lib-search-types';

import type { ConversationsTableFeatures } from '../../../conversationsTable.columns';

export type ConversationsTableConversationPlaceholderRowsProps = {
  /** The table whose columns get a placeholder cell. */
  table: TanstackTable<ConversationsTableFeatures, SearchConversationEnriched>;
  amount?: number;
};

export const ConversationsTableConversationPlaceholderRows = ({
  table,
  amount = 20,
}: ConversationsTableConversationPlaceholderRowsProps): JSX.Element => {
  const columns = table.getVisibleLeafColumns();

  return (
    <>
      {Array.from(Array(amount)).map((_, index) => (
        <Table.Tr key={index}>
          {columns.map((column) => (
            <Table.Td key={column.id} height="65px">
              {column.columnDef.meta?.placeholder?.cell}
            </Table.Td>
          ))}
        </Table.Tr>
      ))}
    </>
  );
};
